import { NgClass } from '@angular/common';
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { LinkedAccountsModalComponent } from '@app/shared/layout/linked-accounts-modal.component';
import { LoginAttemptsModalComponent } from '@app/shared/layout/login-attempts-modal.component';
import { NotificationSettingsModalComponent } from '@app/shared/layout/notifications/notification-settings-modal.component';
import { UserNotificationHelper } from '@app/shared/layout/notifications/UserNotificationHelper';
import { ChangePasswordModalComponent } from '@app/shared/layout/profile/change-password-modal.component';
import { ChangeProfilePictureModalComponent } from '@app/shared/layout/profile/change-profile-picture-modal.component';
import { MySettingsModalComponent } from '@app/shared/layout/profile/my-settings-modal.component';
import { UrlHelper } from '@shared/helpers/UrlHelper';
import { AppComponentBase } from 'shared/common/app-component-base';
import { SessionTimeoutComponent } from './shared/common/session-timeout/session-timeout.component';
import { LinkedAccountsModalComponent as LinkedAccountsModalComponent_1 } from './shared/layout/linked-accounts-modal.component';
import { NotificationSettingsModalComponent as NotificationSettingsModalComponent_1 } from './shared/layout/notifications/notification-settings-modal.component';
import { ChangePasswordModalComponent as ChangePasswordModalComponent_1 } from './shared/layout/profile/change-password-modal.component';
import { ChangeProfilePictureModalComponent as ChangeProfilePictureModalComponent_1 } from './shared/layout/profile/change-profile-picture-modal.component';
import { MySettingsModalComponent as MySettingsModalComponent_1 } from './shared/layout/profile/my-settings-modal.component';
import { ScrollTopComponent } from './shared/layout/scroll-top.component';
import { DefaultLayoutComponent } from './shared/layout/themes/default/default-layout.component';
import { Theme10LayoutComponent } from './shared/layout/themes/theme10/theme10-layout.component';
import { Theme11LayoutComponent } from './shared/layout/themes/theme11/theme11-layout.component';
import { Theme12LayoutComponent } from './shared/layout/themes/theme12/theme12-layout.component';
import { Theme2LayoutComponent } from './shared/layout/themes/theme2/theme2-layout.component';
import { Theme3LayoutComponent } from './shared/layout/themes/theme3/theme3-layout.component';
import { Theme4LayoutComponent } from './shared/layout/themes/theme4/theme4-layout.component';
import { Theme5LayoutComponent } from './shared/layout/themes/theme5/theme5-layout.component';
import { Theme6LayoutComponent } from './shared/layout/themes/theme6/theme6-layout.component';
import { Theme7LayoutComponent } from './shared/layout/themes/theme7/theme7-layout.component';
import { Theme8LayoutComponent } from './shared/layout/themes/theme8/theme8-layout.component';
import { Theme9LayoutComponent } from './shared/layout/themes/theme9/theme9-layout.component';
import { UserDelegationsModalComponent } from './shared/layout/user-delegations-modal.component';

@Component({
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less'],
    imports: [NgClass, DefaultLayoutComponent, Theme2LayoutComponent, Theme3LayoutComponent, Theme4LayoutComponent, Theme5LayoutComponent, Theme6LayoutComponent, Theme7LayoutComponent, Theme8LayoutComponent, Theme9LayoutComponent, Theme10LayoutComponent, Theme11LayoutComponent, Theme12LayoutComponent, ScrollTopComponent, LinkedAccountsModalComponent_1, UserDelegationsModalComponent, ChangePasswordModalComponent_1, ChangeProfilePictureModalComponent_1, MySettingsModalComponent_1, NotificationSettingsModalComponent_1, SessionTimeoutComponent]
})
export class AppComponent extends AppComponentBase implements OnInit {

    theme: string;
    installationMode = true;

    @ViewChild('loginAttemptsModal', { static: true }) loginAttemptsModal: LoginAttemptsModalComponent;
    @ViewChild('linkedAccountsModal', { static: false }) linkedAccountsModal: LinkedAccountsModalComponent;
    @ViewChild('changePasswordModal', { static: true }) changePasswordModal: ChangePasswordModalComponent;
    @ViewChild('changeProfilePictureModal', { static: true }) changeProfilePictureModal: ChangeProfilePictureModalComponent;
    @ViewChild('mySettingsModal', { static: true }) mySettingsModal: MySettingsModalComponent;
    @ViewChild('notificationSettingsModal', { static: true }) notificationSettingsModal: NotificationSettingsModalComponent;
    IsSessionTimeOutEnabled: boolean = this.setting.getBoolean('App.UserManagement.SessionTimeOut.IsEnabled') && this.appSession.userId != null;

    public constructor(
        injector: Injector,
        private readonly _userNotificationHelper: UserNotificationHelper
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this._userNotificationHelper.settingsModal = this.notificationSettingsModal;
        this.theme = abp.setting.get('App.UiManagement.Theme').toLocaleLowerCase();
        this.installationMode = UrlHelper.isInstallUrl(location.href);

        this.registerModalOpenEvents();
    }

    subscriptionStatusBarVisible(): boolean {
        return false;
    }

    subscriptionIsExpiringSoon(): boolean {
        return false;
    }

    registerModalOpenEvents(): void {
        abp.event.on('app.show.loginAttemptsModal', () => {
            this.loginAttemptsModal.show();
        });

        abp.event.on('app.show.linkedAccountsModal', () => {
            this.linkedAccountsModal.show();
        });

        abp.event.on('app.show.changePasswordModal', () => {
            this.changePasswordModal.show();
        });

        abp.event.on('app.show.changeProfilePictureModal', () => {
            this.changeProfilePictureModal.show();
        });

        abp.event.on('app.show.mySettingsModal', () => {
            this.mySettingsModal.show();
        });
    }

    getRecentlyLinkedUsers(): void {
        abp.event.trigger('app.getRecentlyLinkedUsers');
    }

    onMySettingsModalSaved(): void {
        abp.event.trigger('app.onMySettingsModalSaved');
    }
}
